import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export const SUCCESS = "success";
export const ERROR = "error";
export const WARNING = "warning";
export const INFO = "info";

const NotificationStateContext = createContext();
const NotificationActionContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    message: "",
    type: "",
    timeout: 5000,
  });

  const showNotification = useCallback(
    (message, type = SUCCESS, timeout = 5000) => {
      setNotification({ message, type, timeout });
    },
    []
  );

  const stateValue = useMemo(
    () => ({ notification, setNotification }),
    [notification, setNotification]
  );
  const actionValue = useMemo(() => showNotification, [showNotification]);

  return (
    <NotificationStateContext.Provider value={stateValue}>
      <NotificationActionContext.Provider value={actionValue}>
        {children}
      </NotificationActionContext.Provider>
    </NotificationStateContext.Provider>
  );
};

export const useNotificationState = () => {
  return useContext(NotificationStateContext);
};

export const useNotification = () => {
  return useContext(NotificationActionContext);
};
